












import Vue from 'vue';
import {
  Component,
  Prop,
} from 'vue-property-decorator';
import FormFactory from '@/components/FormBuilder/FormFactory.vue';
import {
  Action,
  State,
} from 'vuex-class';

@Component({
  components: {
    FormFactory,
  },
})
export default class FormFactoryModal extends Vue {
  @Prop({
    type: Boolean,
    default: false,
  }) readonly isShown!: boolean

  // Ширина модалки. Default 900 — поведение существующих форм не меняется; отдельные формы
  // (например создание претензии) могут передать шире.
  @Prop({
    type: [String, Number],
    default: 900,
  }) readonly maxWidth!: string | number

  @State('isModalVisible', { namespace: 'entity' })
  readonly isModalVisible!: boolean;

  @Action('toggleEntityModal', { namespace: 'entity' })
  toggleEntityModal: any;

  onClose() {
    this.toggleEntityModal(false);
  }
}

